/* eslint-disable no-param-reassign */

export function slideUp(block) {
  block.style.height = '0';
}
export function slideDown(block) {
  block.style.height = `${block.children[0].offsetHeight}px`;
}
